
import Vue from 'vue'
import Component from 'vue-class-component'
import ChangePassword from '@/components/profile/ChangePassword.vue'
import UserProfile from '@/components/profile/UserProfile.vue'

@Component({
  name: 'Profile',
  components: {
    UserProfile,
    ChangePassword
  }
})
class Profile extends Vue {
  profile: boolean = true
  changePassword: boolean = false

  openChangePassword () {
    this.hideProfile()
    this.showChangePassword()
  }

  openProfile () {
    this.hideChangePassword()
    setTimeout(() => {
      this.showProfile()
    }, 250)
  }

  showProfile () {
    this.profile = true
  }

  hideProfile () {
    this.profile = false
  }

  showChangePassword () {
    this.changePassword = true
  }

  hideChangePassword () {
    this.changePassword = false
  }
}
export default Profile
